import { Menu, MenuOpen } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/joy";
import { createContext, useContext } from "react";

export const LoyaltyNavContext = createContext<{
  isExpanded: boolean;
  setIsExpanded: (isExpanded: boolean) => void;
} | null>(null);

export default function LoyaltyNavToggle({ collapse = false }: { collapse?: boolean }) {
  const navigation = useContext(LoyaltyNavContext);
  if (!navigation || navigation.isExpanded !== collapse) return null;

  const label = collapse ? "Collapse loyalty navigation" : "Expand loyalty navigation";

  return (
    <Tooltip title={label}>
      <IconButton
        size="sm"
        variant="plain"
        color="neutral"
        aria-label={label}
        aria-expanded={navigation.isExpanded}
        aria-controls="loyalty-navigation"
        onClick={() => navigation.setIsExpanded(!navigation.isExpanded)}
      >
        {collapse ? <MenuOpen /> : <Menu />}
      </IconButton>
    </Tooltip>
  );
}
